// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import JsonExcel from 'vue-json-excel'
import App from './App'
import router from './router'
import store from './store'
import api from './api'

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.component('downloadExcel', JsonExcel)

Vue.prototype.$http = api

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js